import { useCallback, useState } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { Campaign } from "@l2r-front/l2r-proptypes"
import { useAlertsDispatchContext } from "@l2r-front/l2r-query"
import { I18N_NAMESPACE } from "@l2r-front/l2r-shared-campaign"
import { UiModal } from "@l2r-front/l2r-ui"

import { CampaignDeliverFormPost } from "../../forms/CampaignDeliverForm"
import { useCampaignTexts } from "../../hooks/useCampaignTexts"

type CampaignDeliverModalProps = {
    campaign: Campaign,
    className?: string,
    open: boolean,
    onClose: () => void,
}

const POPUP_HEIGHT = 484
const POPUP_WIDTH = 514

export function CampaignDeliverModal(props: CampaignDeliverModalProps) {

    const {
        campaign,
        className,
        open,
        onClose,
    } = props

    const [hasOngoingModifications, setHasOngoingModifications] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const { t } = useTranslation([I18N_NAMESPACE])
    const { setAlert } = useAlertsDispatchContext()
    const campaignTexts = useCampaignTexts(campaign.campaign_type, t)

    const handleClose = useCallback((checkModifications = true) => {
        if (checkModifications && hasOngoingModifications) {
            setAlert({
                alertTitle: t(I18N_NAMESPACE, "containers.campaignDeliverModal.alert.title"),
                cancelText: t(I18N_NAMESPACE, "containers.campaignDeliverModal.alert.cancelButton"),
                confirmText: t(I18N_NAMESPACE, "containers.campaignDeliverModal.alert.confirmButton"),
                callback: () => {
                    setHasOngoingModifications(false)
                    onClose()
                },
                open: true,
            })
        } else {
            setHasOngoingModifications(false)
            onClose()
        }
    }, [hasOngoingModifications, t, onClose, setAlert])

    return <UiModal
        className={className}
        id="campaign-deliver-modal"
        height={POPUP_HEIGHT}
        width={POPUP_WIDTH}
        open={open}
        onClose={handleClose}
        title={t(I18N_NAMESPACE, "containers.campaignDeliverModal.title")}
        desc={campaignTexts?.["deliverModalDesc"]}
        showLoader={isSubmitting}
    >
        <CampaignDeliverFormPost
            campaign={campaign}
            onClose={handleClose}
            onChange={setHasOngoingModifications}
            onSubmitting={setIsSubmitting} />
    </UiModal>
}
